<div data-cy="intro">
  <div class="form">
    <ife-title
      [title]="'modules.evcQuote.steps.intro.title' | translate"
      [subtitle]="'modules.evcQuote.steps.intro.subtitle' | translate"
      data-cy="introduction-title"
    ></ife-title>

    <swiper-container
      id="swiper"
      class="lg:max-w-screen-xl mb-12"
      data-cy="swiper"
      appSwiper
      #swiper
      [config]="swiperConfig"
      init="false"
    >
      <swiper-slide class="flow-steps--step" *ngFor="let index of slidesIterator">
        <div class="flow-steps--step-image mr-6 w-52">
          <div class="p-16 rounded-full bg-grey-light box-shadow-small">
            <img
              [src]="'./assets/evc/img/qrf-flow-' + index + '.svg'"
              [alt]="'modules.evcQuote.steps.intro.steps.step' + index | translate"
            />
          </div>
          <span>{{ index }}</span>
        </div>
        <span
          class="flow-steps--step-title"
          [innerHTML]="'modules.evcQuote.steps.intro.steps.step' + index | translate"
        ></span>
        <div *ngIf="index !== 5" class="flow-steps--line"></div>
      </swiper-slide>
    </swiper-container>
  </div>
  <div class="px-8 pb-16 text-center">
    <button class="btn btn-primary block mx-auto" data-cy="start-quote" (click)="navigate()">
      {{ 'modules.evcQuote.steps.intro.ctaButton' | translate }}
    </button>
    <div class="text-center text-xs mt-20 mx-auto" style="max-width: 50rem">
      {{ 'modules.evcQuote.steps.intro.legalConstraints' | translate }}
    </div>
  </div>
</div>
